(window.MyModule = function ($, Behaviors) {

    "use strict";

    var module = {};

    function Resources(elem) {
        Behaviors.init(Resources, this, arguments);

        var $thisElem = this.$elem,
            scrollOffset,
            filterDropdown = $thisElem.parents('.Resources').find('.Resources-dropdown_button'),
            filter = $thisElem.parents('.Resources').find('.Resources-dropdown a');

        // Pagination
        $(document).on("click", '.Resources .Resources-number_pagination a, .Resources .Resources-number_pagination a', function (e) {
            e.preventDefault();

            var $this = $(this),
                postType = $thisElem.data('post-type'),
                category = $thisElem.data('category'),
                paged = $(this).text(),
                current = parseInt($thisElem.find('.Resources-number_pagination .current').text()),
                eventType = postType == 'event' ? $thisElem.parents('.Resources').find('.Resources-dropdown .active').attr('href') : '',
                scrollOffset = $thisElem.parents('.Resources').offset().top - $('header').outerHeight() - 40;

            if ($this.hasClass('prev')) {
                paged = parseInt(current - 1);
            } else if ($this.hasClass('next')) {
                paged = parseInt(current + 1);
            }

            $.ajax({
                url: theme_ajax_url, // AJAX handler
                data: {
                    'action': 'resources_pagination',
                    paged: paged,
                    postType: postType,
                    category: category
                },
                type: 'POST',
                beforeSend: function (xhr) {
                    $thisElem.addClass('Resources-posts--loading');
                },
                success: function (data) {
                    $thisElem.html(data);

                    $thisElem.removeClass('Resources-posts--loading');


                    $('html, body').animate({
                        'scrollTop': scrollOffset
                    }, 500);
                }
            });
            return false;
        });

        // Open Positions Dropdown
        filterDropdown.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            if ($(this).parent().hasClass('Resources-dropdown--open')) {
                filterDropdown.parent().removeClass('Resources-dropdown--open');
            } else {
                filterDropdown.parent().removeClass('Resources-dropdown--open');
                $(this).parent().addClass('Resources-dropdown--open');
            }
        });

        $(document).on('click', function () {
            filterDropdown.parent().removeClass('Resources-dropdown--open');
        });

        // Events Filters
        filter.on('click', function (e) {
            e.preventDefault();
            var $this = $(this),
                postType = $thisElem.data('post-type'),
                category = $thisElem.data('category'),
                eventType = $this.attr('href');

            filter.removeClass('active');
            $this.addClass('active');

            $.ajax({
                url: theme_ajax_url, // AJAX handler
                data: {
                    'action': 'resources_pagination',
                    postType: postType,
                    category: category,
                    eventType: eventType
                },
                type: 'POST',
                beforeSend: function (xhr) {
                    filterDropdown.parent().removeClass('Resources-dropdown--open');
                    filterDropdown.find('.Resources-dropdown_button_text').text($this.text());
                    $thisElem.addClass('Resources-posts--loading');
                },
                success: function (data) {
                    $thisElem.html(data);

                    $thisElem.removeClass('Resources-posts--loading');


                    $('html, body').animate({
                        'scrollTop': scrollOffset
                    }, 500);
                }
            });
            return false;
        });
    }

    Behaviors.inherit(Resources, Behaviors.Behavior);

    Resources.QUERY = "[data-resources-pagination]";

    Behaviors.register_behavior(Resources);

    module.Resources = Resources;

    return module;

}(window.jQuery, window.Behaviors));